<div #combo
     class="z-select"
     role="combobox"
     tabindex="0"
     aria-haspopup="listbox"
     [attr.aria-label]="accessibleName"
     [attr.aria-expanded]="open"
     [attr.aria-controls]="open ? menuId : null"
     [class.has-clear]="selected.length"
     [class.is-open]="open"
     (click)="toggleMenu()"
     (keydown)="onKeydown($event)">

  @if (selected.length === 0) {
    <span class="z-select-placeholder">{{ placeholder }}</span>
  } @else if (multiple) {
    @for (label of labels; track label; let i = $index) {
      <span class="z-chip chip">
        {{ label }}
        <button class="z-chip-x chip-remove" type="button"
                [attr.aria-label]="'Quitar ' + label"
                (click)="remove(i, $event)">&times;</button>
      </span>
    }
  } @else {
    <span class="single-value">{{ labels[0] }}</span>
  }

  <span class="z-select-caret">
    @if (selected.length) {
      <button class="clear" type="button" aria-label="Limpiar selección"
              (click)="clear($event)">&times;</button>
    }
    <i class="bi bi-caret-down-fill" aria-hidden="true"></i>
  </span>

  @if (open) {
    <div class="z-select-menu"
         role="listbox"
         [id]="menuId"
         [attr.aria-label]="accessibleName"
         [attr.aria-multiselectable]="multiple ? true : null"
         (click)="$event.stopPropagation()">
      @for (option of options; track option.value) {
        <button class="opt" type="button" role="option"
                [attr.aria-selected]="isSelected(option)"
                [class.selected]="isSelected(option)"
                (click)="toggle(option)">
          <span>{{ option.label }}</span>
          @if (isSelected(option)) {
            <i class="bi bi-check2 opt-check" aria-hidden="true"></i>
          }
        </button>
      }
      @if (!options.length) {
        <p class="empty" role="presentation">Sin opciones</p>
      }
    </div>
  }

</div>
